/** Update and toggle callbacks for task mutations. */
import { useCallback } from 'react';
import { executeTaskUpdate } from '@/features/tasks/utils/mutations/taskMutationUtils';

export function useTaskUpdateCallbacks({
  allTasks,
  taskTree,
  getAllDescendantIds,
  updateTaskDetails,
  moveTask,
  baseToggleComplete,
  showFollowUpToast,
}) {
  const updateTask = useCallback(
    async (taskId, taskData, userId) => {
      const result = await executeTaskUpdate({
        taskId,
        taskData,
        userId,
        allTasks,
        moveTask,
        taskTree,
        getAllDescendantIds,
        updateTaskDetails,
      });

      if (taskData.completed === true) {
        showFollowUpToast(taskId, userId);
      }

      return result;
    },
    [
      allTasks,
      taskTree,
      getAllDescendantIds,
      updateTaskDetails,
      moveTask,
      showFollowUpToast,
    ],
  );

  const handleToggleComplete = useCallback(
    async (task, completed, focusData = {}) => {
      await baseToggleComplete(task, completed, focusData);
      if (completed && task.userId) {
        showFollowUpToast(task.id, task.userId);
      }
    },
    [baseToggleComplete, showFollowUpToast],
  );

  return { updateTask, handleToggleComplete };
}
